export { default } from './SearchRecommendation';